import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

/* ---------- STATIC DEMO DATA ---------- */
const USER_STATUS = {
  kycApproved: true,
  bankVerified: true,
};

const FUND_INFO = {
  name: "Axis Bluechip Fund",
  nav: "₹52.34",
  cutoffTime: "2:00 PM",
  minAmount: 5000,
};

const BANKS = [
  {
    id: 1,
    name: "HDFC Bank",
    account: "XXXX1234",
  },
  {
    id: 2,
    name: "ICICI Bank",
    account: "XXXX5678",
  },
];

export default function LumpsumInvest() {
  const [amount, setAmount] = useState("");
  const [folio, setFolio] = useState("existing");
  const [bankId, setBankId] = useState(BANKS[0].id);
  const [paymentMethod, setPaymentMethod] = useState("netbanking");
  const [orderCreated, setOrderCreated] = useState(false);

  const isAmountValid = amount >= FUND_INFO.minAmount;

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
      <style>{`
      .btn-outline-custom {
    border: 1px solid rgba(15, 118, 110, 0.12);
    color: #0f766e;
    background: transparent;
}
.card h5 {
  font-weight: 600;
}

.alert {
  font-size: 14px;
}
  button {
    width: max-content;
}
`}</style>

          <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Lumpsum Investment</h3>

            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Lumpsum Investment
                </li>
              </ol>
            </nav>
            </div>

            <div className="card shadow-sm p-4 mb-4">
              <h5 className="mb-3">Lumpsum Investment</h5>
              {/* <h4 className="mb-1" style={{color: '#0d9488'}}>Lumpsum Investment</h4> */}
              <p className="text-muted mb-0">
                {FUND_INFO.name} • NAV {FUND_INFO.nav}
              </p>
            </div>

            {/* Status Validation */}
            <div className="alert alert-success mb-4">
              KYC Approved & Bank Verified ✔
            </div>

            {/* Investment Amount */}
            <div className="card shadow-sm p-4 mb-4">
              <h5 className="mb-3">Investment Amount</h5>
              <input
                type="number"
                className="form-control mb-2"
                placeholder={`Minimum ₹${FUND_INFO.minAmount}`}
                value={amount}
                onChange={(e) => setAmount(Number(e.target.value))}
              />
              {!isAmountValid && amount > 0 && (
                <small className="text-danger">
                  Minimum investment is ₹{FUND_INFO.minAmount}
                </small>
              )}
            </div>

            {/* Folio Selection */}
            <div className="card shadow-sm p-4 mb-4">
              <h5 className="mb-3">Folio</h5>
              <div className="form-check">
                <input
                  type="radio"
                  checked={folio === "existing"}
                  onChange={() => setFolio("existing")}
                  className="form-check-input"
                />
                <label className="form-check-label">Use existing folio</label>
              </div>
              <div className="form-check mt-2">
                <input
                  type="radio"
                  checked={folio === "new"}
                  onChange={() => setFolio("new")}
                  className="form-check-input"
                />
                <label className="form-check-label">Create new folio</label>
              </div>
            </div>

            {/* Bank Selection */}
            <div className="card shadow-sm p-4 mb-4">
              <h5 className="mb-3">Bank Account</h5>
              <select
                className="form-select"
                value={bankId}
                onChange={(e) => setBankId(Number(e.target.value))}
              >
                {BANKS.map((bank) => (
                  <option key={bank.id} value={bank.id}>
                    {bank.name} ({bank.account})
                  </option>
                ))}
              </select>
            </div>

            {/* Payment Method */}
            <div className="card shadow-sm p-4 mb-4">
              <h5 className="mb-3">Payment Method</h5>
              <div className="form-check">
                <input
                  type="radio"
                  checked={paymentMethod === "netbanking"}
                  onChange={() => setPaymentMethod("netbanking")}
                  className="form-check-input"
                />
                <label className="form-check-label">Net Banking</label>
              </div>
              <div className="form-check mt-2">
                <input
                  type="radio"
                  checked={paymentMethod === "upi"}
                  onChange={() => setPaymentMethod("upi")}
                  className="form-check-input"
                />
                <label className="form-check-label">UPI</label>
              </div>
            </div>

            {/* Summary */}
            <div className="card shadow-sm p-4 mb-4">
              <h5 className="mb-3">Order Summary</h5>
              <p>Fund: {FUND_INFO.name}</p>
              <p>Amount: ₹{amount || 0}</p>
              <p>Payment: {paymentMethod.toUpperCase()}</p>
              <p>
                Cutoff: Orders before {FUND_INFO.cutoffTime} get same-day NAV
              </p>
            </div>

            {/* Actions */}
            <div className="card shadow-sm p-4">
              {!orderCreated ? (
                <button
                  className="btn btn-primary"
                  disabled={
                    !USER_STATUS.kycApproved ||
                    !USER_STATUS.bankVerified ||
                    !isAmountValid
                  }
                  onClick={() => setOrderCreated(true)}
                >
                  Create Order & Pay
                </button>
              ) : (
                <>
                  <div className="alert alert-info">Payment processing...</div>
                  <button className="btn  btn-outline-custom">
                    Retry Payment
                  </button>
                </>
              )}
            </div>
          </div>
    </>
  );
}
